import axios from '@/api';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL;

const OneNoteService = {
    async getConnectionStatus() {
        const response = await axios.get(API_URL + "onenote/connection", { headers: authHeader() });
        return response.data;
    },
    async getNotebooks() {
        const response = await axios.get(API_URL + "onenote/notebooks", { headers: authHeader() });
        return response.data;
    },
    async getSections(notebookId) {
        const response = await axios.get(API_URL + `onenote/notebooks/${encodeURIComponent(notebookId)}/sections`,
            {
                headers: authHeader()
            }
        );

        return response.data;
    },
    async getPages(sectionId) {
        const response = await axios.get(API_URL + `onenote/sections/${encodeURIComponent(sectionId)}/pages`,
            {
                headers: authHeader()
            }
        );

        return response.data;
    },
    async getNotes() {
        const response = await axios.get(API_URL + "onenote/notes",
            {
                headers: authHeader()
            }
        );

        return response.data;
    },
    async updateStickyNote({ noteId, content }) {
        await axios.patch(API_URL + "onenote/sticky-notes",{
            noteId,
            content
        }, {
            headers: authHeader()
        });
    },
    async createStickyNote({ subject, content }) {
        const response = await axios.post(
            API_URL + "onenote/sticky-notes",
            {
                subject,
                content
            },
            {
                headers: authHeader()
            }
        );

        return response.data;
    },

    async deleteStickyNote(noteId) {
        await axios.delete(
            API_URL + "onenote/sticky-notes",
            {
                headers: authHeader(),
                data: {
                    noteId
                }
            }
        );
    },
}
export default OneNoteService;